import React, { Fragment, useState } from 'react'
import VehicleDetails from 'components/VehicleDetails'
import ModalContainer from 'modern/components/ModalContainer'
import AutopagoModal from 'components/VehicleDetails/AutopagoModal'
import SantanderLabel from 'components/VehicleDetails/SantanderLabel'
import Button from 'components/Button'
import './style.scss'

export default () => {
	const [modalIsVisible, setModalIsVisible] = useState(false)

	return (
		<Fragment>

			<ModalContainer
				useWhiteBox
				show={modalIsVisible}
				onBgClick={() => setModalIsVisible(false)}
			>
				<AutopagoModal closeCallback={() => setModalIsVisible(false)} />
			</ModalContainer>

			<VehicleDetails>
				<div className="AutopagoInfo">
					<div className="AutopagoInfo__image">
						<img
							src="/assets/img/card_autopago/logo-autopago_red_filled.svg"
							alt="Transação via Autopago"
							title="Transação via Autopago"
						/>
					</div>
					<div className="AutopagoInfo__content">
						<h2>
							Compre via Autopago
							<SantanderLabel />
						</h2>
						<ul>
							<li>Análise cadastral do comprador e do vendedor;</li>
							<li>Seu dinheiro fica seguro com a Webmotors até que a transação seja finalizada.</li>
						</ul>
					</div>
					<div className="AutopagoInfo__action">
						<Button onClick={() => setModalIsVisible(true)}>
							Saiba mais
						</Button>
					</div>
				</div>
			</VehicleDetails>

		</Fragment>
	)
}
